module.exports = __webpack_public_path__ + "img/loader.296a6cd6.svg";